import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Button, FormGroup, FormControl, FormLabel, InputGroup } from 'react-bootstrap';

import PropTypes from 'prop-types';

import { Dots } from 'react-activity';
import 'react-activity/dist/react-activity.css';

import CurrencyCardIcon from '../utils/currency-card-icon.js';



class InvoiceCreateForm extends React.Component {
	
	constructor(props) {
		super(props);
		
		this.app = this.props.app;
		this.getMvcModuleObject = this.app.getMvcModuleObject;
		this.getMvcMyQuoteObject = this.app.getMvcMyQuoteObject;

		this.quote = null;
		this.order = null;
		
		let title = '';
		let description = '';
		let amount = 0;
		let currency = {symbol: ''};
		let signingkey = null;
		let currentcard = null;
		let balance = '';
		
		this.state = {
			title,
			description,
			amount,
			currency,
			signingkey,
			currentcard,
			balance,
			message_text: '',
			vendoraddress: '',
			vendorname: '',
			vendoremail: '',
			processinginfo: 'processing submission',
			processing: false
		};
	}

	
	// post render commit phase
	componentDidUpdate(prevProps, prevState) {
		console.log('InvoiceCreateForm.componentDidUpdate called');
		
		let mvcmyquote = this.getMvcMyQuoteObject();

		let rootsessionuuid = this.props.rootsessionuuid;
		let walletuuid = this.props.currentwalletuuid;
		
		// entered a private key
		if (this.state.signingkey != prevState.signingkey) {
			const {currency} = this.state;

			if ( (currency) && (currency.uuid)) {
				let currentcard = null;
				let balance = '';
				
				let currencyuuid = currency.uuid;

				this.app.createCurrencyCard(currencyuuid, this.state.signingkey, {maincard: true})
				.then(card => {
					currentcard = card;

					return mvcmyquote.getCurrencyPosition(rootsessionuuid, walletuuid, currencyuuid)
				})
				.then((pos) => {
					return mvcmyquote.formatCurrencyAmount(rootsessionuuid, currencyuuid, pos);
				})
				.then((balance) => {
					this.setState({currentcard, balance});
				})
				.catch(err => {
					this.setState({currentcard, balance})
				});
			}
		}
	}

	componentDidMount() {
		console.log('InvoiceCreateForm.componentDidMount called');
		let mvcmodule = this.getMvcModuleObject();
		let mvcmyquote = this.getMvcMyQuoteObject();
		let rootsessionuuid = this.props.rootsessionuuid;
		
		// message translated in user's language
		let message_text = mvcmyquote.t(
			'When you press the button \'Send Invoice\', a url will be generated that you will \
			be able to send to your client asking for the payment of your goods or services. \
			If you haven\'t yet provided your private key, you will be asked to enter it \
			so that your invoice is signed. \
			Your invoice will then be registered and be accessible to anyone clicking on \
			the link that has been generated.');
	
		this.setState({message_text});

		this.checkNavigationState().catch(err => {console.log('error in checkNavigationState: ' + err);});
	}
	
	async checkNavigationState() {
		let mvcmodule = this.getMvcModuleObject();
		let mvcmyquote = this.getMvcMyQuoteObject();

		let rootsessionuuid = this.props.rootsessionuuid;
		let walletuuid = this.props.currentwalletuuid;


		let app_nav_state = this.app.getNavigationState();
		let app_nav_target = app_nav_state.target;
		
		// check wallet is unlocked
		let unlocked = await this.app.checkWalletUnlocked()
		.catch(err => {
		});

		if (!unlocked) {
			let params = (app_nav_target ? app_nav_target.params : null);
			this.app.gotoRoute('login', params);
			return;
		}
		else {
			// check it is not the device wallet, because we need a safer wallet
			let isdevicewallet = await this.app.isDeviceWallet();
			
			if (isdevicewallet) {
				await this.app.resetWallet();
				
			   let params = (app_nav_target ? app_nav_target.params : null);
			   this.app.gotoRoute('login', params);
			   return;
			 }
	   }		

		if (app_nav_target && (app_nav_target.route == 'invoice') && (app_nav_target.reached == false)) {
			let params = app_nav_target.params;
			let dataobj = params.dataobject;

			let order = dataobj;
			this.order = dataobj;

			if (order) {
				let amount = order.amount;
				let currencyuuid = order.currencyuuid;

				// get quote
				let quote = await mvcmyquote.fetchCurrencyTransaction(rootsessionuuid, walletuuid, currencyuuid, order.quote);
				this.quote = quote;

				let title = quote.title;
				let description = quote.description;

				let currency = {symbol: ''};
				let currentcard;
				let balance = '';

				const cur = await mvcmyquote.getCurrencyFromUUID(rootsessionuuid, currencyuuid)
				.catch(err => {});

				if (cur)
				currency = cur;

				// vendor details
				let vendoraddress = '';
				let vendorname = '';
				let vendoremail = '';

				let currentwallet = await mvcmodule.getWalletInfo(rootsessionuuid, walletuuid);

				vendorname = currentwallet.ownername;
				vendoremail = currentwallet.owneremail;

	
				// get currency position
				currentcard = await this.app.openCurrencyCard(currencyuuid)
				.catch(err => {});

				if (currentcard) {
					let pretradecard = await mvcmyquote.getPretradeCard(rootsessionuuid, walletuuid, currentcard.uuid, currencyuuid).catch(err => {});
					vendoraddress = pretradecard.address;

					let pos = await mvcmyquote.getCurrencyPosition(rootsessionuuid, walletuuid, currencyuuid);
			
					if (pos !== undefined)
						balance = await mvcmyquote.formatCurrencyAmount(rootsessionuuid, currencyuuid, pos);
				}
	
			
				this.setState({title, description, amount, currency, vendoraddress, vendorname, vendoremail, currentcard, balance });
	
				dataobj.viewed = true;
			}
			else {
				this.app.error('no data object for invoice create form')
			}
			
			app_nav_target.reached = true;
		}
	}
	
	// user actions
	async onSubmit() {
		console.log('onSubmit pressed!');
		
		let mvcmodule = this.getMvcModuleObject();
		let mvcmyquote = this.getMvcMyQuoteObject();

		let rootsessionuuid = this.props.rootsessionuuid;
		let walletuuid = this.props.currentwalletuuid;
		let wallet;
		let carduuid;
		let card;
		
		let { title, amount, currency, currentcard, signingkey, balance} = this.state;

		this.setState({processing: true});

		try {

			if (!currency || !currency.uuid) {
				this.app.alert('You need to specify a valid currency');
				this.setState({processing: false});
				return;
			}
	
			// get wallet details
			wallet = await mvcmodule.getWalletInfo(rootsessionuuid, walletuuid);
	
			if (currentcard) {
				card = currentcard;
				carduuid = card.uuid;
			}
			else {
				if (signingkey) {
					let currencyuuid = currency.uuid;
		
					card = await this.app.createCurrencyCard(currencyuuid, signingkey, {maincard: true})
					.catch(err => {
						console.log('error in InvoiceCreateForm.onSubmit: ' + err);
					});
	
					if (!card) {
						this.app.alert('could not create card from private key');
						this.setState({processing: false});
						return;
					}
				}
				else {
					this.app.alert('You need to provide your private key for ' + currency.name + ' in invoice to sign your quote');
					this.setState({processing: false});
					return;
				}
		
			}
	
			// we get the pretrade card to save a transaction
			let pretradecard = await mvcmyquote.getPretradeCard(rootsessionuuid, walletuuid, carduuid, currency.uuid)
			.catch(err => {
				console.log('error in InvoiceCreateForm.onSubmit: ' + err);
			});
	
			if (!pretradecard) {
				this.app.alert('Could not get a card to register the invoice');
				this.setState({processing: false});
				return;
			}
	
			// we top-up pretrade card to be sure being able to send a transaction
			const topupinfo = await mvcmodule.topUpCard(rootsessionuuid, walletuuid, pretradecard.uuid)		
			.catch(err => {
				console.log('error in InvoiceCreateForm.onSubmit: ' + err);
			});
	
			if ((!topupinfo) || (!topupinfo.top) ) {
				this.app.alert('Could not top up account to register invoice. Wait a few seconds and try again.');
				this.setState({processing: false});
				return;
			}
			else {
				let transactioninfo = await mvcmyquote.getSchemeTransactionInfo(rootsessionuuid, pretradecard.schemeuuid);

				if (topupinfo.balance <= (transactioninfo ? transactioninfo.credits_threshold :  1)) {
					this.app.alert('Account has not been topped-up yet. Wait a few seconds and try again.');
					this.setState({processing: false});
					return;
				}
			}
			
			// quote owner
			let quote = this.quote;
			let decryptcard = await mvcmyquote.getWalletDecryptingCard(rootsessionuuid, walletuuid, quote.owner);
	
			// decrypt buyer's details with the buyer's public key for the send
			let order = this.order;
			let buyer_address = order.owner;
			let buyer_rsa_publickey = order.owner_rsa_publickey;
	
			let buyername_encrypted = order.ownername;
			let buyeremail_encrypted = order.owneremail;
	
			let buyername = await mvcmyquote.rsaDecryptString(rootsessionuuid, walletuuid, decryptcard.uuid, buyer_rsa_publickey, buyername_encrypted)
			.catch(err => {
				console.log('error in InvoiceCreateForm.onSubmit: ' + err);
			});
	
			let buyeremail = await mvcmyquote.rsaDecryptString(rootsessionuuid, walletuuid, decryptcard.uuid, buyer_rsa_publickey, buyeremail_encrypted)
			.catch(err => {
				console.log('error in InvoiceCreateForm.onSubmit: ' + err);
			});
	
	
			// we crypt our details with the buyer's public key
			// using our pretradecard that will provide our owner_rsa_publickey
			let vendorname = wallet.ownername
			let vendoremail = wallet.owneremail;
	
			const vendorname_encrypted = await mvcmyquote.rsaEncryptString(rootsessionuuid, walletuuid, pretradecard.uuid, buyer_rsa_publickey, vendorname)
			.catch(err => {
				console.log('error in InvoiceCreateForm.onSubmit: ' + err);
			});
			const vendoremail_encrypted = await mvcmyquote.rsaEncryptString(rootsessionuuid, walletuuid, pretradecard.uuid, buyer_rsa_publickey, vendoremail)
			.catch(err => {
				console.log('error in InvoiceCreateForm.onSubmit: ' + err);
			});
	
	
			// send transaction
			let vendor_address = pretradecard.address;
			let vendor_rsa_publickey = pretradecard.publickeys['rsa_public_key'];
	
	
			let invoice = {type: 'invoice', order: order.txhash, currencyuuid: currency.uuid,
						amount, currency: currency.symbol,
						owner: vendor_address, owner_rsa_publickey: vendor_rsa_publickey, ownername: vendorname_encrypted, owneremail: vendoremail_encrypted};
			let assignto = buyer_address;
	
			let txhash = await mvcmyquote.registerTransaction(rootsessionuuid, walletuuid, pretradecard.uuid, invoice, assignto)
			.catch(err => {
				console.log('error in InvoiceCreateForm.onSubmit: ' + err);
			});
	
			if (!txhash) {
				this.app.alert('Could not register the invoice');
				this.setState({processing: false});
				return;
			}
	
			// get share link
			//var invoiceurl = await this.app.getShareLink(txhash, currency.uuid);
	
			// send link by mail
			let sharelinkmessage = {};
				
			sharelinkmessage.to = [];
			sharelinkmessage.to.push(buyeremail);
	
			sharelinkmessage.subject = mvcmyquote.t('invoice') + ' ' + mvcmodule.fitString(txhash, 12);
			
			sharelinkmessage.message = 'This mail contains the invoice details for invoice ' + txhash + '.\r\n\r\n';
	
			// link in message
			sharelinkmessage.linkformat = 'plain';
			
			sharelinkmessage.route = '';
			
			sharelinkmessage.params = {};
			
			sharelinkmessage.params.tx = invoice.txhash;
			sharelinkmessage.params.ccy = invoice.currencyuuid;
			
			await this.app.sendShareLink(sharelinkmessage);
			
	
			// go to list view (to let time for the blockchain to commit the transactions)
			let params = {action: 'view', txhash, currencyuuid: currency.uuid};
	
			await this.app.gotoRoute('invoices', params);
	
			this.setState({processing: false});
	
			return true;
		}
		catch(e) {
			console.log('exception in onSubmit: ' + e);
			this.setState({processing: false});
		}

	}

	
	// rendering
	renderInvoiceCreateForm() {
		let { title, description, amount, currency, currentcard, vendoraddress, vendorname, vendoremail, signingkey, balance, message_text } = this.state;
		
		return (
			<div className="Form">
				<div>
					<FormGroup controlId="title">
						<FormLabel>Quote Title</FormLabel>
						<FormControl
							disabled
							autoFocus
							type="text"
							value={title}
							onChange={e => this.setState({title: e.target.value})}
						/>
					</FormGroup>

					<FormGroup controlId="VendorAddress">
						<FormLabel>Vendor Address {(currency && currency.name ? 'for ' + currency.name : '')}</FormLabel>
						<FormControl
							autoFocus
							type="text"
							value={vendoraddress}
							onChange={e => this.setState({vendoraddress: e.target.value})}
						/>
					</FormGroup>

					<FormGroup controlId="VendorName">
						<FormLabel>Vendor Name</FormLabel>
						<FormControl
							disabled
							autoFocus
							type="text"
							value={vendorname}
							onChange={e => this.setState({vendorname: e.target.value})}
						/>
					</FormGroup>

					<FormGroup controlId="VendorEmail">
						<FormLabel>Vendor Email</FormLabel>
						<FormControl
							disabled
							autoFocus
							type="text"
							value={vendoremail}
							onChange={e => this.setState({vendoremail: e.target.value})}
						/>
					</FormGroup>

					<FormGroup className="Proposal" controlId="proposal">
						<span className="ProposalCol">
							<FormLabel>Amount</FormLabel>
							<FormControl 
								disabled
								autoFocus
								type="text"
								value={amount}
								onChange={e => this.setState({amount: e.target.value})}
							/>
						</span>

						<span className="ProposalCol">
							<FormLabel>Currency</FormLabel>
							<InputGroup>
								<FormControl 
									disabled
									autoFocus
									type="text"
									value={currency.symbol}
									onChange={e => this.onChangeCurrency(e)}
								/>
							</InputGroup>
						</span>

					</FormGroup>

					{(currentcard ?
						<FormGroup className="CurrencyCard" controlId="address">
							<span className="CardIconCol">
								<CurrencyCardIcon
									app={this.app}
									currency={currency}
									card={currentcard}
								/>
							</span>
							<span className="CardBalanceCol">
								<FormLabel>Balance</FormLabel>
								<FormControl
									className="CardBalanceCol"
									disabled
									autoFocus
									type="text"
									value={balance}
								/>
							</span>
						</FormGroup> :
						<FormGroup controlId="signingkey">
							<FormLabel>Private key {(currency && currency.name ? 'for ' + currency.name : '')}</FormLabel>
							<FormControl
								autoFocus
								type="text"
								value={(signingkey ? signingkey : '')}
								onChange={e => this.setState({signingkey: e.target.value})}
							/>
						</FormGroup>
					)}
					
					<Button 
					disabled={(currentcard ? false : true)}
					onClick={this.onSubmit.bind(this)} 
					type="submit">
					Send Invoice
					</Button>

					<div className="TextBox">
					{message_text}
					</div>

				</div>
			</div>
		  );
	}

	render() {
		let {processing} = this.state; 

		if (processing === true) {
			return (
				<div className="Splash">
					<div>{this.state.processinginfo}</div>
					<Dots />
				</div>
			);
		}
		
		return (
			<div className="Container">
				<div className="Title">Create Invoice</div>
				{ this.renderInvoiceCreateForm()}
			</div>
		  );
	}
	
}


// propTypes validation
InvoiceCreateForm.propTypes = {
	app: PropTypes.object.isRequired,
	rootsessionuuid: PropTypes.string,
	currentwalletuuid: PropTypes.string,
};

//redux
const mapStateToProps = (state) => {
	return {
		rootsessionuuid: state.session.sessionuuid,
		pending: state.login.pending,
		success: state.login.success,
		lasterror: state.login.error,
		currentwalletuuid: state.wallets.walletuuid,
	};
}

const mapDispatchToProps = (dispatch) => {
	return {
	};
}


export {InvoiceCreateForm};
export default connect(mapStateToProps, mapDispatchToProps)(InvoiceCreateForm);

